"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _reactRouter = require("react-router");

var _Prompt = require("@quixeltools/quixel-ui-library/dist/components/bridge/popups/Prompt");

var _Prompt2 = _interopRequireDefault(_Prompt);

var _Checkbox = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Checkbox");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _user = require("../../redux/modules/user");

var _auth = require("../../redux/modules/auth");

var _styles = require("./styles.scss");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var icon = "/quixel_2080_logo.png";

var CouponRedeemForm = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(CouponRedeemForm, _React$Component);

  function CouponRedeemForm(props) {
    (0, _classCallCheck3.default)(this, CouponRedeemForm);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CouponRedeemForm.__proto__ || (0, _getPrototypeOf2.default)(CouponRedeemForm)).call(this, props));

    _this.onSubmitHandler = _this.onSubmitHandler.bind(_this);
    _this.onChangeHandler = _this.onChangeHandler.bind(_this);
    _this.state = {
      coupon: null,
      userType: null,
      termsChecked: false
    };
    return _this;
  }

  (0, _createClass3.default)(CouponRedeemForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({ termsChecked: !this.props.shouldUpdateEula });
    }
  }, {
    key: "onChangeHandler",
    value: function onChangeHandler() {
      this.setState({
        termsChecked: !this.state.termsChecked
      });
    }
  }, {
    key: "onSubmitHandler",
    value: function onSubmitHandler() {
      var _props = this.props,
          redeemCode = _props.redeemCode,
          coupon = _props.coupon,
          type = _props.type,
          onCloseYes = _props.onCloseYes,
          acceptEULA = _props.acceptEULA,
          shouldUpdateEula = _props.shouldUpdateEula;

      if (type === "lt") {
        try {
          redeemCode(coupon).then(function () {
            if (shouldUpdateEula) {
              acceptEULA();
            }
            onCloseYes();
            setTimeout(function () {
              // wait until call completes.
              if (__CLIENT__) {
                window.location = window.location.protocol + "//" + window.location.hostname + "/megascans/home";
              }
            }, 100);
          });
        } catch (error) {
          console.log(error);
        }
      } else if (type === "ee") {
        onCloseYes();
        _reactRouter.browserHistory.push({
          pathname: "/"
        });
      } else {
        onCloseYes();
        if (__CLIENT__) {
          window.location = window.location.protocol + "//" + window.location.hostname + "/megascans/home";
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          user = _props2.user,
          type = _props2.type,
          shouldUpdateEula = _props2.shouldUpdateEula;
      var loading = user.loading;


      var title = "";
      var buttonLable = "Ok";
      var disableButton = loading;

      if (type === "nt" || type == "ut") {
        title = "Welcome";
      } else if (type === "lt") {
        title = "Licence agreement";
        buttonLable = "Accept";
        disableButton = this.state.termsChecked !== true;
      } else if (type === "ee") {
        title = "Link expired";
      }

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          _Prompt2.default,
          {
            icon: icon,
            title: title,
            buttonLabel: buttonLable,
            onSubmit: this.onSubmitHandler,
            disabled: disableButton || !this.state.termsChecked
          },
          type === "lt" && _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(
              "div",
              { className: _styles2.default.content },
              _react2.default.createElement(
                "p",
                { className: _styles2.default.para },
                "By accepting the license agreement you will get:"
              ),
              _react2.default.createElement("br", null),
              _react2.default.createElement(
                "ul",
                { className: _styles2.default.listing },
                _react2.default.createElement(
                  "li",
                  null,
                  "1000 points to use for Megascans"
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  "Access to all Metahuman assets"
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  "All surfaces from rd-textures.com"
                )
              )
            ),
            shouldUpdateEula && _react2.default.createElement(
              "div",
              { className: _styles2.default.agreement },
              _react2.default.createElement(_Checkbox2.default, {
                className: _styles2.default.checkbox,
                label: "",
                touched: false,
                checked: this.state.termsChecked,
                onClick: this.onChangeHandler
              }),
              _react2.default.createElement(
                "span",
                null,
                "I agree to the\xA0",
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: _styles2.default.link, target: "_blank", to: "/terms" },
                  "Content License Agreement."
                )
              )
            )
          ),
          type === "nt" && _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(
              "div",
              { className: _styles2.default.content },
              _react2.default.createElement(
                "p",
                { className: _styles2.default.para },
                "You now have instant access to:"
              ),
              _react2.default.createElement("br", null),
              _react2.default.createElement(
                "ul",
                { className: _styles2.default.listing },
                _react2.default.createElement(
                  "li",
                  null,
                  "1000 points to use for Megascans"
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  "All surfaces from rd-textures.com"
                )
              )
            ),
            _react2.default.createElement("br", null),
            _react2.default.createElement(
              "p",
              { className: _styles2.default.para },
              "Happy creating!"
            )
          ),
          type === "ut" && _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(
              "div",
              { className: _styles2.default.content },
              _react2.default.createElement(
                "p",
                { className: _styles2.default.para },
                "You now have instant access to:"
              ),
              _react2.default.createElement("br", null),
              _react2.default.createElement(
                "ul",
                { className: _styles2.default.listing },
                _react2.default.createElement(
                  "li",
                  null,
                  "All surfaces from rd-textures.com"
                )
              )
            ),
            _react2.default.createElement("br", null),
            _react2.default.createElement(
              "p",
              { className: _styles2.default.para },
              "Happy creating!"
            )
          ),
          type === "ee" && _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(
              "div",
              { className: _styles2.default.content },
              _react2.default.createElement(
                "p",
                { className: _styles2.default.para },
                "This link is no longer valid because you may have already used it."
              )
            )
          )
        )
      );
    }
  }]);
  return CouponRedeemForm;
}(_react2.default.Component), _class.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.user,
    shouldUpdateEula: state.auth.eula.updateVersion
  };
}, { redeemCode: _user.redeemCode, acceptEULA: _auth.acceptEULA })(CouponRedeemForm);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CouponRedeem/CouponRedeem.jsx
// module id = 2849
// module chunks = 0